declare namespace $ {

	export class $shm_hitalama_benchmarks_runner extends $mol_view {
		listen( ): any
		content( ): readonly(any)[]
		auto( ): readonly(any)[]
		sub( ): ReturnType< $shm_hitalama_benchmarks_runner['content'] >
	}
	
}

//# sourceMappingURL=runner.view.tree.d.ts.map